import React from "react";
import Routes from "../../../routes";
import useDeviceListText from "./useDeviceListText";
import { ViewSwitchGroup, ViewSwitchLink } from "./devices.styles";

interface IProps {
  current: "machines" | "outlets";
}

/** Switches the X10 section between the machine list and the outlet list. */
const X10ViewSwitch: React.FC<IProps> = ({ current }) => {
  const text = useDeviceListText();

  return (
    <ViewSwitchGroup role="tablist">
      <ViewSwitchLink
        role="tab"
        aria-selected={current === "machines"}
        selected={current === "machines"}
        to={Routes.x10Machines}
      >
        {text("view_machines", "Machines")}
      </ViewSwitchLink>
      <ViewSwitchLink
        role="tab"
        aria-selected={current === "outlets"}
        selected={current === "outlets"}
        to={Routes.extra10Outlets}
      >
        {text("view_outlets", "Outlets")}
      </ViewSwitchLink>
    </ViewSwitchGroup>
  );
};

export default X10ViewSwitch;
